<template>
    <div>
        <div class="nav-title" style="margin-top:30px;text-align: left">
                     <span style="width:107px;
                     margin-left: 5%;
                     height:18px;
                     font-size:18px;
                     font-weight:400;
                     color:rgba(0,162,202,1);">装企云管家 > </span><span style="width:71px;
                    height:17px;
                    font-size:18px;
                    font-family:MicrosoftYaHei;
                    font-weight:400;
                    color:rgba(0,162,202,1);">{{stepState[step].aliasName}}</span>
        </div>

        <div class="circle-step" style="margin: 11px auto 0;width: 841px;">
            <div class="big-circle" v-bind:class="[stepState[0].isActive ? 'active' : '']"><i>1</i><span class="sss">填写资料</span>
            </div>
            <span class="sm-circle" v-bind:class="[stepState[0].isActive ? 'active' : '']"></span>
            <span class="sm-circle" v-bind:class="[stepState[0].isActive ? 'active' : '']"></span>
            <span class="sm-circle" v-bind:class="[stepState[0].isActive ? 'active' : '']"></span>
            <span class="sm-circle" v-bind:class="[stepState[0].isActive ? 'active' : '']"
                  style="margin-right:22px;"></span>
            <div class="big-circle" v-bind:class="[stepState[1].isActive ? 'active' : '']"><i>2</i><span class="sss">站点配置</span>
            </div>
            <span class="sm-circle" v-bind:class="[stepState[1].isActive ? 'active' : '']"></span>
            <span class="sm-circle" v-bind:class="[stepState[1].isActive ? 'active' : '']"></span>
            <span class="sm-circle" v-bind:class="[stepState[1].isActive ? 'active' : '']"></span>
            <span class="sm-circle" v-bind:class="[stepState[1].isActive ? 'active' : '']"
                  style="margin-right:22px;"></span>
            <div class="big-circle" v-bind:class="[stepState[2].isActive ? 'active' : '']"><i>3</i><span class="sss">扫码支付</span>
            </div>
            <span class="sm-circle" v-bind:class="[stepState[2].isActive ? 'active' : '']"></span>
            <span class="sm-circle" v-bind:class="[stepState[2].isActive ? 'active' : '']"></span>
            <span class="sm-circle" v-bind:class="[stepState[2].isActive ? 'active' : '']"></span>
            <span class="sm-circle" v-bind:class="[stepState[2].isActive ? 'active' : '']"
                  style="margin-right:22px;"></span>
            <div class="big-circle" v-bind:class="[stepState[3].isActive ? 'active' : '']"><i>4</i><span class="sss">生成站点</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "StepState",
        data: function () {
            return {
                step: 0,
                stepState: [
                    {name: 'client', aliasName: '填写资料', isActive: true},
                    {name: 'siteConfig', aliasName: '站点配置', isActive: false},
                    {name: 'payMeal', aliasName: '扫码支付', isActive: false},
                    {name: 'buildSite', aliasName: '生成站点', isActive: false},
                ],
            }
        },
        watch: {
            $route: function (route) {
                this.stepState.forEach((s, i) => {
                    s.name === route.name && (this.step = i)
                })
                this.stepState.forEach((s, i) => {
                    s.isActive = i <= this.step ? true : false
                })
            }
        }
    }
</script>

<style scoped>

</style>